import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IScheduleDocInfo } from 'src/app/ViewModel/ScheduleDocumentModel';

@Component({
  selector: 'app-schedule-document-view-popup',
  templateUrl: './schedule-document-view-popup.component.html',
  styleUrls: ['./schedule-document-view-popup.component.css']
})
export class ScheduleDocumentViewPopupComponent implements OnInit {

  viewSchDoc: IScheduleDocInfo | null = {
    doc_Id: 0,
    revision_No: '',
    doc_No: '',
    doc_Title: '',
    doc_Set_Name: '',
    doc_Status: '',
    doc_Status_Id: 0,
    print_Size: '',
    print_Size_Id: 0,
    revision_Category: 0,
    authorized_By: '',
    created_By: '',
    created_On: undefined,
    reference: '',
    comments: '',
    stages: '',
    is_Latest: false,
    is_WF_Started: false,
    can_Restart_WF: false,
    dciScheduleStageDetails: [],
    dciScheduleElementDetails: [],
    isSelected: false,
    approved_Tag: false,
    approved_On: undefined,
    isShowSupersedeIcon: false
  };
  constructor(public dialogRef: MatDialogRef<ScheduleDocumentViewPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }


  ngOnInit(): void {
    if(this.data)
    {
      console.log(this.viewSchDoc)
      this.viewSchDoc.doc_Id = this.data.doc_id
      this.viewSchDoc.revision_No = this.data.revision_No
      this.viewSchDoc.approval_Date = this.data.approval_date
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
